/**
  * Created by iDS
  * Do not edit directly. Generated using https://github.com/itau-corp/itau-sd4-dep-ids-tokens
*/

export const Themes = {
  Area_de_pessoas: "area_de_pessoas",
  Atlas: "atlas",
  Cartao_branco: "cartao_branco",
  Credicard: "credicard",
  Credicard_on: "credicard_on",
  Decathlon: "decathlon",
  Empresas: "empresas",
  Emps: "emps",
  Fast_shop_pay: "fast_shop_pay",
  Hipercard: "hipercard",
  Icarros: "icarros",
  Ids: "ids",
  Investment_service: "investment_service",
  Ion: "ion",
  Itau_bba: "itau_bba",
  Itau_gestao_de_ativos: "itau_gestao_de_ativos",
  Itaucard: "itaucard",
  Iti: "iti",
  Magalu: "magalu",
  Oca: "oca",
  Pao_de_acucar: "pao_de_acucar",
  Personal_bank: "personal_bank",
  Personnalite: "personnalite",
  Players_bank: "players_bank",
  Private: "private",
  Rede: "rede",
  Samsung: "samsung",
  Uniclass: "uniclass",
  Varejo: "varejo",
  Vivo: "vivo",
  Varejo_beta: "varejo_beta",
  Uniclass_beta: "uniclass_beta",
};